export default __webpack_public_path__ + "static/media/ionicons.175f391f.woff2";